import React, { type FC, useEffect, useRef } from 'react';

import { Button } from '@shared/ui/button';
import { ContactItem } from '@shared/ui/contact-item';
import { useNotifications } from '@entities/notifications';
import IconPhoneIncoming from '@assets/img/icons/phone-incoming.svg';
import IconVolumeNope from '@assets/img/icons/volume-nope.svg';

import { useCallsList } from '../../hooks';
import type { IncomingCallProps } from './types';

import styles from './styles.module.scss';

export const IncomingCall: FC<IncomingCallProps> = ({
	id,
	fromUri,
	isConference,
	onAnswer,
	onReject,
	onMute,
}) => {
	const incomingMsgId = useRef<string | null>(null);
	const { pushNotification, removeNotificationById, updateNotification } = useNotifications();
	const { currentCall } = useCallsList();
	const hasActiveCall = Boolean(currentCall);

	const handleReject = () => {
		if (!incomingMsgId.current) return;

		onReject(id);
		removeNotificationById(incomingMsgId.current);
	};

	const handleAnswer = () => {
		if (!incomingMsgId.current) return;

		onAnswer(id, false);
		removeNotificationById(incomingMsgId.current);
	};

	const incomingCall = (
		<div>
			<ContactItem
				name={fromUri}
				infoDescription={
					<div className={styles.DirectionContainer}>
						<div
							className={styles.DirectionIcon}
							dangerouslySetInnerHTML={{
								__html: IconPhoneIncoming,
							}}
						/>
						<div className={styles.DirectionText}>
							{isConference ? 'Конференция' : 'Входящий звонок'}
						</div>
					</div>
				}
				rightAddons={
					<Button
						buttonType="icon"
						className={styles.MuteBlock}
						hint="Выключить звук"
						svg={IconVolumeNope}
						onClick={onMute}
					/>
				}
			/>
			<div className={styles.Separator} />

			{hasActiveCall && (
				<div className={styles.InfoMessage}>Текущий звонок будет поставлен на удержание</div>
			)}

			<div className={styles.Buttons}>
				<Button onClick={handleReject}>Отклонить</Button>

				<Button buttonType="primary" onClick={handleAnswer}>
					Ответить
				</Button>

				{/* <Button */}
				{/*    onClick={() => onAnswer(true)} */}
				{/*    buttonType={"primary"} */}
				{/* > */}
				{/*    Принять с видео */}
				{/* </Button> */}
			</div>
		</div>
	);

	useEffect(() => {
		incomingMsgId.current = pushNotification({ message: incomingCall });

		return () => {
			if (incomingMsgId.current) {
				removeNotificationById(incomingMsgId.current);
			}
		};
	}, []);

	useEffect(() => {
		if (incomingMsgId.current) {
			updateNotification(incomingMsgId.current, { message: incomingCall });
		}
	}, [hasActiveCall]);

	return null;
};
